/** 도는 중 표시 — 공통 `.b-spinner`(고리, sm 12 · md 14 · lg 16). **움직임은 유일한 신호가 아니다** —
 *  부르는 쪽이 aria-busy 나 글자로 같은 사실을 함께 말한다. 「동작 줄이기」에서는 멈추지 않고 느리게
 *  돈다(공통 규칙 — 멈춘 고리는 「느린 것」이 아니라 「멎은 것」으로 읽힌다). */
export function Spinner({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const cls = size === "sm" ? "b-spinner is-sm" : size === "lg" ? "b-spinner is-lg" : "b-spinner";
  return <span className={cls} role="presentation" />;
}
